import React from 'react'
import './nav.css'
import { FaHome } from "react-icons/fa";
import {BsInfoCircle,BsPuzzle,BsMailbox} from "react-icons/bs"
import {IoCodeSlash} from "react-icons/io5"
import { useState } from 'react';

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#')
  return (
    <nav>
      <a href="/#" onClick={()=> setActiveNav('#')} className={activeNav === '#' ? 'active':''}><FaHome /></a>
      <a href="#about" onClick={()=> setActiveNav('#about')} className={activeNav === '#about' ? 'active':''} ><BsInfoCircle /></a>
      <a href="#experience" onClick={()=> setActiveNav('#experience')} className={activeNav === '#experience' ? 'active':''}><BsPuzzle /></a>
      <a href="#playground" onClick={()=> setActiveNav('#playground')} className={activeNav === '#playground' ? 'active':''}><IoCodeSlash /></a>
      <a href="#contact" onClick={()=> setActiveNav('#contact')} className={activeNav === '#contact' ? 'active':''}><BsMailbox /></a>
    </nav>
  )
}

export default Nav